
// PESO_SESION_SEGURA_V8
const BASE = 'mercadobulk_pesos_v1';
let orden = Promise.resolve();

const enOrden = fn => {
  const tarea = orden.catch(() => {}).then(fn);
  orden = tarea.catch(() => {});
  return tarea;
};

function abrir() {
  return new Promise((resolve, reject) => {
    const r = indexedDB.open(BASE, 1);

    r.onupgradeneeded = () => {
      const db = r.result;

      if (!db.objectStoreNames.contains('archivos')) {
        const a = db.createObjectStore('archivos', {
          keyPath: 'id'
        });
        a.createIndex('usuario', 'usuario', {
          unique: false
        });
      }

      if (!db.objectStoreNames.contains('sesiones')) {
        db.createObjectStore('sesiones', {
          keyPath: 'usuario'
        });
      }
    };

    r.onsuccess = () => resolve(r.result);
    r.onerror = () => reject(r.error);
    r.onblocked = () => reject(
      new Error('Cierra otras pestañas con esta sesión')
    );
  });
}

async function tx(stores, modo, accion) {
  const db = await abrir();

  return new Promise((resolve, reject) => {
    const t = db.transaction(stores, modo);
    let resultado;

    t.oncomplete = () => {
      db.close();
      resolve(resultado);
    };

    t.onerror = () => {
      const e = t.error;
      db.close();
      reject(e);
    };

    t.onabort = () => {
      const e = t.error;
      db.close();
      reject(e || new Error('Transacción cancelada'));
    };

    try {
      accion(t, v => {
        resultado = v;
      });
    } catch (e) {
      try {
        t.abort();
      } catch (_) {}
      reject(e);
    }
  });
}

export function guardarArchivosPeso(usuario, archivos) {
  if (!usuario || !archivos.length) {
    return Promise.resolve();
  }

  return enOrden(() => tx(
    ['archivos'],
    'readwrite',
    t => {
      const a = t.objectStore('archivos');

      for (const f of archivos) {
        a.put({
          id: usuario + ':' + f.nombre,
          usuario,
          nombre: f.nombre,
          estructura: f.estructura
        });
      }
    }
  ));
}

export function guardarEstadoPeso(usuario, estado) {
  if (!usuario) {
    return Promise.reject(
      new Error('Usuario no disponible')
    );
  }

  return enOrden(() => tx(
    ['sesiones'],
    'readwrite',
    t => t.objectStore('sesiones').put({
      usuario,
      estado
    })
  ));
}

export async function recuperarSesionPeso(usuario) {
  if (!usuario) {
    return { archivos: [], estado: null };
  }

  await orden;

  return tx(
    ['archivos', 'sesiones'],
    'readonly',
    (t, resolver) => {
      let archivos = [];
      let estado = null;
      let pendientes = 2;

      const listo = () => {
        if (--pendientes === 0) {
          resolver({ archivos, estado });
        }
      };

      t.objectStore('archivos')
        .index('usuario')
        .getAll(usuario)
        .onsuccess = e => {
          archivos = e.target.result || [];
          listo();
        };

      t.objectStore('sesiones')
        .get(usuario)
        .onsuccess = e => {
          estado = e.target.result?.estado || null;
          listo();
        };
    }
  );
}

export function borrarSesionPeso(usuario) {
  if (!usuario) {
    return Promise.resolve();
  }

  return enOrden(() => tx(
    ['archivos', 'sesiones'],
    'readwrite',
    t => {
      const a = t.objectStore('archivos')
        .index('usuario');

      a.openCursor(usuario).onsuccess = e => {
        const c = e.target.result;

        if (c) {
          c.delete();
          c.continue();
        }
      };

      t.objectStore('sesiones').delete(usuario);
    }
  ));
}
